import { Pen, Plus } from "lucide-react";
import { useState, PropsWithChildren, FC } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "../ui/dialog";
import { Button } from "../ui/button";
import FormWizard from "react-form-wizard-component";
import { DropdownMenuItem } from "../ui/dropdown-menu";

interface Props extends PropsWithChildren {
  title: string;
  confirmForm: Function;
  buttonTitle?: string;
  isEdit?: boolean;
  id?: number;
}

const CreateWizardCommon: FC<Props> = ({
  title,
  confirmForm,
  buttonTitle,
  isEdit = false,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const openDialog = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsOpen(true);
  };

  const checkValidateTab = (proceed?: Function) => {
    const activeForm = document.querySelector(
      ".reservation-form-step",
    ) as HTMLFormElement | null;
    if (activeForm) {
      if (activeForm.reportValidity()) {
        if (proceed) proceed();
      } else {
        return false;
      }
    }

    return false;
  };

  return (
    <>
      {isEdit ? (
        <DropdownMenuItem onClick={openDialog}>
          <Pen className="w-4 h-4" />
          Edit
        </DropdownMenuItem>
      ) : (
        <Button onClick={openDialog}>
          <Plus className="w-4 h-4" /> {buttonTitle || "Add row"}
        </Button>
      )}
      {isOpen && (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
          <DialogContent className="sm:max-w-[600px] max-h-[90vh] overflow-y-auto overflow-x-hidden" onClick={(e: React.MouseEvent) => e.stopPropagation()}>
            <DialogHeader>
              <DialogTitle>Create new {title}</DialogTitle>
              <DialogDescription>
                Fill all the step forms. Once finished, click save on the last
                step. Navigate through each step to make changes
              </DialogDescription>
            </DialogHeader>
            <FormWizard
              shape="circle"
              nextButtonTemplate={(handleNext: Function) => (
                <Button
                  type="button"
                  className="float-right "
                  onClick={() => checkValidateTab(handleNext)}
                >
                  Next
                </Button>
              )}
              backButtonTemplate={(handlePrev: () => void) => (
                <Button
                  onClick={handlePrev}
                  type="button"
                  className="mb-4 min-[351px]:mb-0"
                >
                  Back
                </Button>
              )}
              finishButtonTemplate={() => (
                <Button
                  type="submit"
                  className="float-right"
                  onClick={() => {
                                          checkValidateTab(confirmForm);

                  }}
                  disabled={loading}
                >
                  {loading ? "Saving..." : "Save"}
                </Button>
              )}
            >
              {children}
            </FormWizard>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
};

export default CreateWizardCommon;
